<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import FormFieldTemplateLarge from '../forms/FormFieldTemplateLarge.svelte';
  import SelectField from '../forms/SelectField.svelte';
  import InlineButton from '../buttons/InlineButton.svelte';
  import FontIcon from '../icons/FontIcon.svelte';
  import FormStyledButton from '../buttons/FormStyledButton.svelte';

  export let selectedTable;
  export let changeTable;

  export let label;
  export let field;

  export let allowNoColumns = false;
</script>

<FormFieldTemplateLarge {label} type="combo">
  {#key selectedTable?.name + '||' + selectedTable[field]?.length}
    {#each selectedTable[field] ?? [] as col, index}
      <div class="flex flex1">
        <SelectField
          isNative
          value={col}
          on:change={e => {
            changeTable(selectedTable.name, table => ({
              ...table,
              [field]: selectedTable[field]?.map((v, i) => (i == index ? e.detail : v)),
            }));
          }}
          options={selectedTable?.tableInfo?.columns?.map(col => ({
            label: col.columnName,
            value: col.columnName,
          })) || []}
        />
        {#if index == 0}
          <InlineButton
            on:click={() => {
              const column1 =
                selectedTable.tableInfo?.primaryKey?.columns?.[0]?.columnName ??
                selectedTable.tableInfo?.columns?.[0]?.columnName;

              changeTable(selectedTable.name, table => ({
                ...table,
                [field]: [...(selectedTable[field] ?? []), column1],
              }));
            }}
            title="Add column"
            square
          >
            <FontIcon icon="icon plus-thick" />
          </InlineButton>
          {#if allowNoColumns && selectedTable[field]?.length == 1}
            <InlineButton
              on:click={() => {
                changeTable(selectedTable.name, table => ({
                  ...table,
                  [field]: selectedTable[field]?.filter((x, i) => i != index),
                }));
              }}
              title="Remove column"
              square
            >
              <FontIcon icon="icon minus-thick" />
            </InlineButton>
          {/if}
        {:else}
          <InlineButton
            on:click={() => {
              changeTable(selectedTable.name, table => ({
                ...table,
                [field]: selectedTable[field]?.filter((x, i) => i != index),
              }));
            }}
            title="Remove column"
            square
          >
            <FontIcon icon="icon minus-thick" />
          </InlineButton>
        {/if}
      </div>
    {/each}
  {/key}
  {#if allowNoColumns && !selectedTable[field]?.length}
    <FormStyledButton
      value="Add column"
      on:click={() => {
        changeTable(selectedTable.name, table => ({
          ...table,
          [field]: [selectedTable.tableInfo?.columns?.[0]?.columnName],
        }));
      }}
    />
  {/if}
</FormFieldTemplateLarge>
